import { env } from '../env'
import { Configuration } from './configuration'
import { fetch, processError } from './fetch'

export const configuration: Configuration = {
    basePath: env.endpoint
}

export abstract class BaseApi {
    protected fetch = fetch
    protected call = async (func: () => any) => {
        try {
            return await func()
        } catch (err) {
            return processError(err)
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/BaseApi.ts